import { Progress } from "./progress";
import { usePage } from "@tree-company/tree-query";
import clsx from "clsx";
import { useContext, useEffect, useMemo, useRef } from "react";
import { LocaleContext, RootContext } from "../app";
import { Footer } from "./footer";
import { STATEMENTS } from "../data/statements";
import { Tellit } from "./tellit";

function stepForPageKey(key) {
  if (key.startsWith("opinion")) {
    return 1;
  } else if (key.startsWith("comment")) {
    return 2;
  } else if (key === "name") {
    return 3;
  } else if (key === "sociodemo") {
    return 4;
  } else if (key === "like") {
    return 5;
  } else if (key === "optin") {
    return 6;
  }
}

export function PageComponent({
  handleSave,
  page,
  children,
  onPreviousPage,
  className,
}) {
  const { title, description, htmlAttributes, key } = usePage(page);
  const elementRef = useRef();
  const { translate } = useContext(LocaleContext);
  const step = useMemo(() => stepForPageKey(key), [key]);
  const [statementName, statement] = useMemo(() => {
    const name = page.treesponse.getAnswer("statement");
    return [name, STATEMENTS[name]];
  }, [key]);
  const root = useContext(RootContext);

  // Make sure the browsers back button has the same effect as our back button
  useEffect(() => {
    const goBack = (event) => {
      event.preventDefault();
      onPreviousPage();
    };
    window.addEventListener("popstate", goBack, { once: true });
    return () => window.removeEventListener("popstate", goBack, { once: true });
  }, [key]);

  useEffect(() => {
    // If our context has defined fathom, we send fake pages with the current step of the form
    if (window.fathom) {
      const locationWithKey = new URL(window.location);
      locationWithKey.pathname += `/${key}`;
      window.fathom.trackPageview({ url: locationWithKey.toString() });
    }
  }, [key]);

  useEffect(() => {
    const { top, left } = root.getBoundingClientRect();
    window.scrollTo({ top: window.scrollY + top, left });
  }, [key]);

  return (
    <>
      {step === 1 && <Tellit name={statementName} url={statement.tellitURL} />}

      <main className={clsx("app__container", className)} ref={elementRef}>
        <div className="card">
          <form
            action=""
            className={clsx("survey", htmlAttributes.class)}
            onSubmit={handleSave}
          >
            <Progress
              title={translate(["statements", statementName, "shortName"])}
              onBackButton={onPreviousPage}
              step={step}
            />
            {(title || description) && (
              <div className="survey__intro">
                {title && <h1 className="survey__title">{title}</h1>}
                {description && <p className="survey__text">{description}</p>}
              </div>
            )}

            {children}

            {page.settings.showNext !== false && (
              <button className="survey__action">
                {translate("general.next_page")}
              </button>
            )}
          </form>
          <Footer />
        </div>
      </main>
    </>
  );
}
